import React, { useCallback, useContext } from "react";

import { Slide } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import FoodDatabase from "@/components/FoodDatabase";
import { FoodAddPortionDetailsFragment, FoodItemFragment } from "@/gql/graphql";

import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme) => ({
  foodDatabase: {
    alignSelf: "flex-start",
    position: "sticky",
    top: theme.spacing(4),
    width: "calc(30% - 12px)",
    marginLeft: theme.spacing(2),
    verticalAlign: "top",
    zIndex: 10,
  },
  foodDatabaseOpen: {
    display: "block",
  },
  foodDatabaseClose: {
    display: "none",
  },
}));

const SearchFoodPanel: React.FC = observer(() => {
  const { classes, cx } = useStyles();

  const store = useContext(MealPlanFormStore.Context);
  const activeCell = store.cells.active;
  const foodDatabaseOpen = !!activeCell;

  const handleAddFood = useCallback(
    (
      food: FoodItemFragment,
      foodPortion: FoodAddPortionDetailsFragment,
      amount: number
    ) => {
      if (activeCell == null) return;
      activeCell.addItem(food, foodPortion, amount);
    },
    [activeCell]
  );

  return (
    <Slide in={foodDatabaseOpen} direction="left">
      <div
        className={cx(classes.foodDatabase, {
          [classes.foodDatabaseOpen]: foodDatabaseOpen,
          [classes.foodDatabaseClose]: !foodDatabaseOpen,
        })}
      >
        <FoodDatabase
          onClose={() => store.cells.clearActive()}
          onAddFood={handleAddFood}
          clientAllergies={store.clientAllergies}
        />
      </div>
    </Slide>
  );
});

export default SearchFoodPanel;
